<template>
    <outboxCon :bg="bg">
        <div class="cloud-learn">
            <app-title main='云学习平台' sub='打通所有教学场景的数据，帮助老师掌握孩子学习情况'></app-title>
            <div class="cloud-learn-box">
                <div class="cloud-learn-item" v-for="(item, index) in cloudList" :key="`cloud${index}`">
                    <img class="cloud-img" :src="item.url">
                    <div class="cloud-info">
                        <p class="main">{{item.main}}</p>
                        <p class="sub">{{item.sub}}</p>
                    </div>
                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
import methosScroll from './hashScroll/methodScroll'
import { cloudList } from '@/const/index'
export default {
  props: {
    bg: {
      type: String,
      default: ''
    },
    teacherUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      cloudList: cloudList
    }
  },
  components: { methosScroll }
}
</script>
<style lang="scss" scoped>
    .cloud-learn{
        width: $main-width;
        margin: 0 auto;
        padding: 50px 0px 60px 82px;
        position: relative;
        .cloud-learn-box{
            width: 1110px;
            margin-top: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            .cloud-learn-item{
                margin-top: 20px;
                width:543px;
                height:152px;
                background:#F8F9FD;
                border-radius:4px;
                border:1px solid #EEEEEE;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .cloud-img{
                    width: 179x;
                    height: 150px;
                }
                .cloud-info{
                    height: 100%;
                    flex: 1;
                    background: #ffffff;
                    text-align: left;
                    padding: 29px 19px 0px;
                    .main{
                        font-size:20px;
                        font-family:PingFangSC-Medium,PingFang SC;
                        line-height:28px;
                    }
                    .sub{
                        margin-top: 14px;
                        font-size:14px;
                        font-family:PingFangSC-Regular;
                        line-height:20px;
                    }
                }
                &:nth-child(odd){
                    margin-right: 20px;
                }
            }
        }
    }
</style>
